import type { SingleEvent } from 'lib/queries/events';
import type { Blocks as BlocksType } from 'types/blocks';
import type { GetStaticPaths, GetStaticProps } from 'next';

import { useRouter } from 'next/router';
import { getSingleEvent } from 'lib/queries/events';
import Loader from 'components/loader';
import PageWrap from 'components/page-wrap';
import HeroVpd from 'components/hero-vpd';
import Blocks from 'components/blocks';

const EventContent: React.FC<SingleEvent> = ({
  event: {
    title,
    seo,
    acf: {
      hero,
      pageType,
      blocks,
      states,
      vpdPartnerName,
      vpdLogo,
      price,
      patientRenewalDropdown,
      patientRenewalDropdownInfo,
    },
  },
  events,
}) => {
  return (
    <PageWrap seo={seo} title={title} pageType={pageType}>
      <HeroVpd
        hero={hero}
        states={states}
        vpdPartnerName={vpdPartnerName}
        vpdLogo={vpdLogo}
        price={price}
        events={events}
        patientRenewalDropdown={patientRenewalDropdown}
        patientRenewalDropdownInfo={patientRenewalDropdownInfo}
      />
      {blocks && blocks.length > 0 && (
        <Blocks pageType={pageType} blocks={blocks as BlocksType[]} />
      )}
    </PageWrap>
  );
};

const SingleEvent: React.FC<SingleEvent> = props => {
  const { isFallback } = useRouter();

  if (isFallback) {
    return <Loader />;
  }

  return <EventContent {...props} />;
};

export const getStaticProps: GetStaticProps = async context => {
  return await getSingleEvent(context);
};

export const getStaticPaths: GetStaticPaths = async context => {
  return { paths: [], fallback: 'blocking' };
};

export default SingleEvent;
